import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./app/providers/AuthProvider";
import { LayoutProvider } from "./app/providers/LayoutProvider";
import { QueryProvider } from "./app/providers/QueryProvider";
import { AppRouter } from "./app/router";
import { Toaster } from "./components/ui/toaster";
import { ZebraPrinterProvider } from "./features/printer";
import { ErrorBoundary } from "./shared/components/ErrorBoundary";
import "./index.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryProvider>
        <AuthProvider>
          <LayoutProvider>
            <ZebraPrinterProvider>
              <AppRouter />
              <Toaster />
            </ZebraPrinterProvider>
          </LayoutProvider>
        </AuthProvider>
      </QueryProvider>
    </ErrorBoundary>
  </StrictMode>
);
